import React from "react";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";

export default function Footer({ onQuote }) {
  return (
    <footer id="contact" className="relative overflow-hidden border-t border-white/10 bg-[#0B1320] pt-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 pb-16 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div>
              <p className="font-display text-lg font-extrabold uppercase text-white">Suryavansh Exim</p>
              <p className="data-label text-[0.6rem]">Private Limited</p>
            </div>
            <p className="mt-6 max-w-sm font-display text-2xl font-bold leading-snug text-white sm:text-3xl">
              Connecting India, <span className="text-[#E65100]">Delivering World.</span>
            </p>
            <button
              onClick={onQuote}
              data-testid="footer-quote-btn"
              className="group mt-7 inline-flex items-center gap-2 rounded-full bg-[#E65100] px-6 py-3 font-semibold text-white transition-all duration-300 hover:bg-[#FF6D00]"
            >
              Start a Shipment
              <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
          </div>

          <div>
            <p className="data-label mb-4">Navigate</p>
            <ul className="space-y-3 text-slate-300">
              {["Services", "Products", "Process", "Network"].map((l) => (
                <li key={l}><a href={`#${l.toLowerCase() === "process" ? "manifesto" : l.toLowerCase()}`} className="transition-colors hover:text-[#D4AF37]">{l}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="data-label mb-4">Get in Touch</p>
            <a href="mailto:info@suryavanshexim.com" data-testid="footer-email" className="flex items-start gap-3 text-slate-300 transition-colors hover:text-[#D4AF37]">
              <Mail className="mt-0.5 h-5 w-5 text-[#E65100]" />
              <span className="break-all">info@suryavanshexim.com</span>
            </a>
            <div className="mt-4 flex items-start gap-3 text-slate-300">
              <MapPin className="mt-0.5 h-5 w-5 text-[#E65100]" />
              <span>India — Serving 42 countries worldwide</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-7 sm:flex-row">
          <p className="font-mono-t text-xs text-slate-500">© {new Date().getFullYear()} Suryavansh Exim Private Limited. All rights reserved.</p>
          <p className="font-mono-t text-xs text-slate-500">EXPORT • IMPORT • ON-DEMAND TRADE</p>
        </div>
      </div>
      <div className="pointer-events-none select-none overflow-hidden">
        <p className="whitespace-nowrap text-center font-display text-[16vw] font-extrabold uppercase leading-none text-white/[0.03]">Suryavansh</p>
      </div>
    </footer>
  );
}
